export default "__VITE_ASSET__a680a7e2__"